import { Alert } from '@mui/material';
import React from 'react';

interface ErrorComponentProps {
  text: string;
  center?: boolean;
}

const ErrorComponent: React.FC<ErrorComponentProps> = ({ text, center = false }) => {
  return (
    <Alert severity="error" variant="filled" sx={{ maxWidth: 800, margin: center ? '0 auto' : undefined }}>
      {text}
    </Alert>
  );
};

export default ErrorComponent;
